"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M15.01 3c-.41 0-.77.12-1.05.4-.27.29-.39.67-.39 1.1 0 .29.05.56.18.79.13.23.3.41.52.53.22.12.47.18.72.18.41 0 .77-.12 1.04-.41.28-.29.39-.67.39-1.1 0-.29-.05-.55-.18-.79-.12-.22-.29-.4-.51-.52-.22-.12-.46-.18-.72-.18zm.75 4h-1.52c-.45 0-.86.09-1.2.29-.314.1847-.5605.4287-.7381.7406l-2.0676 3.6358-2.741.0003c-.3 0-.5733.06-.8.1933-.2266.1333-.4.3133-.52.5467-.12.2266-.1733.48-.1733.76v4.5h1.3333V21h1.3334v-3.3333H10c0-1.5568-.0068-3.1135.0008-4.6703h1.0071L12 11.252V16h2v5h2v-5h2V9.25c0-.42-.08-.8-.26-1.14-.18-.35-.44-.62-.77-.82-.35-.2-.76-.29-1.21-.29z"
  }), _react.default.createElement("path", {
    d: "M7.9972 11.0003c.6619 0 1.1985-.473 1.1985-1.2658 0-.8126-.5366-1.2658-1.1985-1.2658-.6618 0-1.1984.4613-1.1984 1.2658 0 .7955.5366 1.2658 1.1984 1.2658z"
  })];
};

exports.default = _default;